import { GrFormDown } from "react-icons/gr";
import styles from "./EventGuestList.module.css";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import config from "@config/config";
import { Spinner } from "@components/Spinner/Spinner";
import PaymobComponent from "@components/Payments/paymob/PaymobPixel";

const stripePromise = loadStripe(config.STRIPE_PK, { stripeApplePay: true });
const stripePromiseUAE = loadStripe(config.STRIPE_PK_UAE, { stripeApplePay: true });

const CheckoutFormAreeba = ({ gatewayData, orderData }) => {
  const { areebaOperation, session } = gatewayData;
  const { receiptID, orderAmounts, currency } = orderData;
  const [scriptLoading, setScriptLoading] = useState(true);
  const [scriptError, setScriptError] = useState(null);

  useEffect(() => {
    const loadScript = async () => {
      try {
        const script = document.createElement("script");
        script.src = "https://epayment.areeba.com/static/checkout/checkout.min.js";
        script.async = true;
        script["data-complete"] = `${window.location.origin}/receipt/${receiptID}?type=guestListAreeba`;
        script.onload = () => {
          setScriptLoading(false);
          window.Checkout.configure({ session: { id: session.id } });
          window.Checkout.showEmbeddedPage("#embed-target");
        };
        script.onerror = (err) => setScriptError(err);
        document.getElementById("mainDiv").appendChild(script);
      } catch (error) {
        setScriptError(error);
      } finally {
        setScriptLoading(false);
      }
    };
    loadScript();
  }, [session, receiptID]);

  return (
    <div id="mainDiv" style={{ backgroundColor: "white", borderRadius: "15px", padding: "5px 3px" }}>
      {scriptError && <p>Error loading script: {scriptError.message}</p>}
      <div id="embed-target" style={{ width: "80%", margin: "0 auto" }}></div>
      {scriptLoading && <Spinner />}
    </div>
  );
};

const CheckoutFormStripe = ({ clientSecret, paymentIntentID }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(null);

    if (!stripe || !elements) {
      setLoading(false);
      return;
    }

    try {
      await elements.submit();
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: { return_url: `${window.location.origin}/receipt/${paymentIntentID}?type=guestList` },
      });
      if (error) setErrorMessage(error.message);
    } catch (error) {
      setErrorMessage("An error occurred during payment.");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {errorMessage && <p style={{ color: "red", fontSize: "11px" }}>{errorMessage}</p>}
      <button disabled={!stripe || loading} className={styles.pay_btn} type="submit">
        {loading ? "Loading.." : "Pay Now"}
      </button>
    </form>
  );
};

const GuestListPayment = ({ closeDialog, event, guestList, guestInfo, gatewayData, orderData, gateway }) => {
  const { name: eventName, imageUrl: eventImage } = event;
  const { currency, guestListName } = guestList;
  const { orderAmounts, quantity } = orderData;
  const { clientSecret, paymentIntentID } = gatewayData;

  const [isExpanded, setIsExpanded] = useState(false);
  const handleExpandClick = () => setIsExpanded(!isExpanded);

  return (
    <div className={styles.panel_wrapper}>
      <div className={styles.panel_header}>
        <h3 className={styles.titleText}>Request to Join List</h3>
        <button className={styles.closeButton} onClick={closeDialog}>&times;</button>
      </div>
      <div className={styles.top}>
        <div className={styles.title}><h1>Review & Pay</h1></div>
        <div className={styles.event_box} onClick={handleExpandClick}>
          <Image className={styles.eventImage} src={eventImage} alt={eventName} width={120} height={120} priority />
          <div className={styles.info}>
            <span className={styles.eventName}>{eventName}</span>
            <span className={styles.item}>{quantity} Item{quantity > 1 && "s"}</span>
          </div>
          <GrFormDown className={`${styles.arrow} ${isExpanded ? styles.arrowDown : ""}`} />
        </div>
        {isExpanded && (
          <div className={styles.expandableContent}>
            <div className={styles.selectedItems}>
              <span>{quantity}x</span>
              <div className={styles.ticketInfo}>
                <span>{guestListName}</span>
                <span>{orderAmounts.card.baseAmount} {currency}</span>
              </div>
            </div>
          </div>
        )}
        <div style={{ marginTop: "10px", fontSize: "18px" }}>
          <div><span style={{ opacity: "80%" }}>Subtotal:</span> {orderAmounts.card.baseAmount} {currency}</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ opacity: "80%" }}>Service Fees:</span> {orderAmounts.card.serviceFees} {currency}
            <span className={styles.gradientText}><span style={{ opacity: "80%", color: "white" }}>Total:</span> {orderAmounts.card.customerAmount} {currency}</span>
          </div>
        </div>
        {gateway.toLowerCase().includes("stripe") && (
          <Elements stripe={gatewayData["stripe-account"] === "UK" ? stripePromise : stripePromiseUAE} options={{ clientSecret }}>
            <CheckoutFormStripe clientSecret={clientSecret} paymentIntentID={paymentIntentID} />
          </Elements>
        )}
        {gateway.toLowerCase() === "areeba" && <CheckoutFormAreeba gatewayData={gatewayData} orderData={orderData} />}
        {gateway.toLowerCase() === "paymob" && <PaymobComponent publicKey="are_pk_test_Rer393e7CU38tWNyLlECfEQVk51R7CLe" paymentData={{ gatewayData, orderData }} paymentMethod="card" elementId="myDiv" />}
      </div>
    </div>
  );
};

export default GuestListPayment;
